import { AxiosInstance } from "axios";

export interface ExportUrlResponse {
  message: string;
  exportUrl: string;
  expiresAt: string;
  exportedAt: string;
  recordCount: number;
}

export const fetchExportUrl = (
  api: AxiosInstance
): Promise<{ data: ExportUrlResponse }> => {
  return api.post("/community_requests/export", {});
};
